import { render } from "./PlpContainer.vue?vue&type=template&id=4fa947e3"
import script from "./PlpContainer.vue?vue&type=script&lang=js"
export * from "./PlpContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__